var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-row',_vm._l((_vm.catalog.cataloglists),function(listable){return _c('v-col',{key:listable.id,attrs:{"cols":listable.cols}},[_vm._v("\n      "+_vm._s(listable.id)+"\n    ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }